import React, { useEffect } from "react";
import { RootContextProvider, RootStore } from "Store/RootStore";
import { observer, useLocalObservable } from "mobx-react";

import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { AuthProvider } from "./Auth/AuthProvider";
import { ORPCClientProvider } from "./oRPC/ORPCClientProvider";
import { ReactQueryProvider } from "./Query/ReactQueryProvider";
import { Spinner } from "@fluentui/react-components";
import { onSnapshot } from "mobx-state-tree";

const RootStoreProviderBase = (props: { children: React.ReactNode }) => {
    const store = useLocalObservable(RootStore);

    useEffect(() => {
        store.init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(
        () =>
            onSnapshot(store.GlobalSetting, (snapshot) => {
                try {
                    const settingValue = JSON.stringify(snapshot);
                    localStorage.setItem(store.SettingStorageKey, settingValue);
                } catch (error) {
                    console.warn("Failed to cache settings to localStorage:", error);
                }
            }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return store.isInit ? (
        <RootContextProvider value={store}>
            <AppInsightsContext.Provider value={store.LogStore.reactPlugin}>
                <ReactQueryProvider>
                    <ORPCClientProvider>
                        <AuthProvider>{props.children}</AuthProvider>
                    </ORPCClientProvider>
                </ReactQueryProvider>
            </AppInsightsContext.Provider>
        </RootContextProvider>
    ) : (
        <Spinner aria-busy="true" aria-label="Loading Content" />
    );
};

export const RootStoreProvider = observer(RootStoreProviderBase);
